import { createLogic } from 'redux-logic';
import { RECEIVED_UPDATE_ALERTS_AND_NOTIFICATIONS } from 'state/alertsAndNotifications/AlertsAndNotificationsActions';
import { hideFixedFooterSaveOptions } from 'state/preferences/PreferencesActions';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionSuccess } from 'state/analytics/AnalyticsActions';
import { titleCase } from 'services/Formats';

const UpdateAlertsAndNotificationsLogic = createLogic({
  type: [RECEIVED_UPDATE_ALERTS_AND_NOTIFICATIONS],

  process({ action }, dispatch, done) {
    // dispatch user message
    dispatch(addToast(true, 'Changes Saved'));

    // dispatch analytics message
    const type = titleCase(action.type.slice('RECEIVED_'.length), '_', '');
    dispatch(analyticsActionSuccess('ProfPref', type));

    // hide save options after successful response
    dispatch(hideFixedFooterSaveOptions());

    done();
  }
});

export default UpdateAlertsAndNotificationsLogic;
